import apiClient from './apiClient';
import axios from 'axios';

const feedApi = {
  getFeed: (params?: Record<string, string | number>) =>
    apiClient.get('/feed', { params }).then((r) => r.data),

  getHotties: () => apiClient.get('/feed/hotties').then((r) => r.data),

  // Public endpoint — no auth required, used on landing/auth pages
  getShowcaseProfiles: () =>
    axios.get(`${process.env.API_BASE_URL}/v1/profiles/showcase`).then((r) => r.data),
};

export default feedApi;
